import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "faq-area pb-100" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = {
  class: "col-lg-6",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "100"
}
const _hoisted_5 = { class: "faq-content" }
const _hoisted_6 = { class: "top-title" }
const _hoisted_7 = { class: "text-white" }
const _hoisted_8 = { class: "accordion" }
const _hoisted_9 = { class: "accordion-header" }
const _hoisted_10 = ["aria-expanded", "onClick"]
const _hoisted_11 = { class: "accordion-collapse collapse show" }
const _hoisted_12 = { class: "accordion-body" }
const _hoisted_13 = {
  class: "col-lg-6",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "200"
}
const _hoisted_14 = { class: "faq-img" }
const _hoisted_15 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.c.top_title), 1),
            _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.c.title), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.c.items, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(["accordion-item", { active: _ctx.activeIndex === index }])
              }, [
                _createElementVNode("h2", _hoisted_9, [
                  _createElementVNode("button", {
                    class: "accordion-button",
                    type: "button",
                    "aria-expanded": _ctx.activeIndex === index ? 'true' : 'false',
                    onClick: ($event: any) => (_ctx.toggleAccordion(index))
                  }, _toDisplayString(item.question), 9, _hoisted_10)
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("p", null, _toDisplayString(item.answer), 1)
                  ])
                ], 512), [
                  [_vShow, _ctx.activeIndex === index]
                ])
              ], 2))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("img", {
              src: _ctx.c.image_url || _ctx.faqImg,
              alt: "faq"
            }, null, 8, _hoisted_15)
          ])
        ])
      ])
    ])
  ]))
}